import * as config from '../../config_module';
import { PARAMS } from '../../const';

const API_PREFIX = '/api/v1';
const API_PREFIX_V2 = '/api/v2';
const API_CMS_PREFIX = '/api/v1';

// API BACKEND CLASSROOM

// USERS
export const API_USERS = `${config.BACKEND_URL}${API_PREFIX}/users`;
export const API_USER_SECTIONS = `${API_USERS}/${PARAMS.USER}/section`;
export const API_USERS_PIN_CODE = `${API_USERS}/${PARAMS.USER}/pinCode`;
export const API_USERS_SINGUP = `${config.BACKEND_URL}${API_PREFIX}/users/classroom`;
export const API_USERS_GOOGLE = `${API_USERS}/google`;
export const API_USERS_AZURE = `${API_USERS}/azure`;
export const API_USERS_LOGIN = `${API_USERS}/login/classroom`;
export const API_USERS_REFRESH_TOKEN = `${API_USERS}/refresh-token`;
export const API_USERS_LOGIN_GOOGLE = `${API_USERS}/login/google`;
export const API_USERS_LOGIN_AZURE = `${API_USERS}/login/azure`;
export const API_USERS_FORGOT = `${API_USERS}/${PARAMS.EMAIL}/forgotPassword`;
export const API_USERS_RESET = `${API_USERS}/resetPassword/${PARAMS.TOKEN}`;
export const API_USERS_CLASSROOMS = `${API_USERS}/${PARAMS.USER}/classrooms`;
export const API_USER_PICTURE = `${API_USERS}/${PARAMS.USER}/picture`;
export const API_USERS_CLASSROOM = `${API_USERS}/${PARAMS.USER}/classroom/${PARAMS.CLASSROOM}`;
export const API_USERS_ASSIGNMENTS = `${API_USERS}/${PARAMS.USER}/tasks`;
export const API_USERS_ASSIGNMENTS_PAGINATION = `${API_USERS_ASSIGNMENTS}?page=${PARAMS.PAGE}&perPage=${PARAMS.ITEMS}`;
export const API_USERS_CONFIGURATION = `${API_USERS}/${PARAMS.USER}/configuration`;
// GUEST ACCESS
export const API_GUEST_VALIDATE = `${config.BACKEND_URL}${API_PREFIX}/guest/validate`;
export const API_GUEST_SESSION = `${config.BACKEND_URL}${API_PREFIX}/guest/session`;
// CLASSROOM
export const CLASSROOMS_ROUTE = '/classroom';
export const API_CLASSROOMS = `${config.BACKEND_URL}${API_PREFIX}/classrooms`;
export const API_CLASSROOM = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}`;
export const API_CLASSROOM_COMPONENTS = `${API_CLASSROOM}/components?unitActivityId=${PARAMS.UNIT_ACTIVITY_ID}`;
export const API_CLASSROOMS_PICTURE = `${API_CLASSROOM}/picture`;
export const API_CLASSROOMS_PARTICIPANTS = `${API_CLASSROOM}/participants`;
export const API_CLASSROOMS_STUDENTS = `${API_CLASSROOM}/students`;
export const API_CLASSROOMS_TEACHERS = `${API_CLASSROOM}/teachers`;
export const API_CLASSROOMS_BOOKS = `${API_CLASSROOM}/books`;
export const API_CLASSROOMS_BOOK = `${API_CLASSROOM}/books/${PARAMS.BOOK}`;
export const API_CLASSROOM_IMPORT_UNIT = `${API_CLASSROOMS_BOOK}/units`;
export const API_CLASSROOM_IMPORT_LESSON = `${API_CLASSROOMS_BOOK}/lessons`;
export const API_CLASSROOM_CLONE_LESSON = `${config.BACKEND_URL}${API_PREFIX}/cloneLesson`;
export const API_NEAE_ADAPTATIONS = `${config.BACKEND_URL}${API_PREFIX}/neae-adaptations`;
export const API_CLASSROOMS_BOOK_ORDER = `${API_CLASSROOMS_BOOK}/order`;
export const API_CLASSROOMS_BOOKS_SYNC = `${API_CLASSROOMS_BOOK}/classrooms`;
export const API_CLASSROOMS_BOOKS_CMI5 = `${API_CLASSROOMS_BOOK}/cmi5`;
export const API_CONTENT_ASSIGNATION_BY_GROUPS = `${API_CLASSROOM}/books/${PARAMS.BOOK}/groups`;
export const API_CONTENT_ASSIGNATION_BY_USERS = `${API_CLASSROOM}/books/${PARAMS.BOOK}/users`;
export const API_CONTENT_ASSIGNATION_BY_GROUP = `${API_CONTENT_ASSIGNATION_BY_GROUPS}/${PARAMS.GROUP}?activityId=${PARAMS.ACTIVITY}`;
export const API_CONTENT_ASSIGNATION_BY_USER = `${API_CONTENT_ASSIGNATION_BY_USERS}/${PARAMS.USER}?activityId=${PARAMS.ACTIVITY}`;
export const API_CLASSROOMS_GROUPS = `${API_CLASSROOM}/groups`;
export const API_ACTIVITIES = `${API_CLASSROOMS}/${PARAMS.CLASSROOM}/activities`;
export const API_CONTENT_BY_ACTIVITY_ID = `${API_ACTIVITIES}/children?activityId=${PARAMS.ACTIVITY}`;
export const API_ACTIVITIES_BY_ACTIVITY_ID = `${API_ACTIVITIES}?activityId=${PARAMS.ACTIVITY}`;
export const API_ACTIVITIES_BY_PARENT_ID = `${API_ACTIVITIES}?parentId=${PARAMS.ACTIVITY}`;
export const API_CLASSROOM_GOOGLE_LAUNCH = `${API_CLASSROOMS}/${PARAMS.CLASSROOM_ID}/activities/launch`;
// VIDEOCALL
export const API_CLASSROOM_VIDEOCALL = `${config.BACKEND_URL}${API_PREFIX}/videocall/classroom/${PARAMS.CLASSROOM_ID}`;
export const API_CLASSROOM_VIDEOCALL_UPDATE_OR_CREATE = `${config.BACKEND_URL}${API_PREFIX}/videocall`;
// GOOGLE CLASSROOM
export const API_CLASSROOM_GOOGLE = `${config.BACKEND_URL}${API_PREFIX}/google`;
export const API_CLASSROOM_GOOGLE_IS_CONNECTED = `${config.BACKEND_URL}${API_PREFIX}/google/is-connected`;
export const API_CLASSROOM_GOOGLE_CONNECT = `${config.BACKEND_URL}${API_PREFIX}/google/connect`;
export const API_CLASSROOM_GOOGLE_COURSES = `${API_CLASSROOM_GOOGLE}/courses`;
export const API_CLASSROOM_GOOGLE_MEET = `${API_CLASSROOM_GOOGLE}/meet`;
export const API_CLASSROOM_GOOGLE_CONNECTION = `${API_CLASSROOM_GOOGLE}/connection`;
export const API_CLASSROOM_GOOGLE_SHARE_CONTENT = `${API_CLASSROOM_GOOGLE}/classroom/${PARAMS.GOOGLE_COURSE_ID}/share-content`;
// SECTIONS
export const API_SECTIONS = `${config.BACKEND_URL}${API_PREFIX}/sections`;
export const API_SECTION_BY_ID = `${API_SECTIONS}/${PARAMS.SECTION}`;
export const API_SECTION_ACTIVITIES_BY_PARENT_ID = `${API_SECTION_BY_ID}/activities?parentId=${PARAMS.ACTIVITY}`;
export const API_SECTION_PIN_CODES = `${API_SECTION_BY_ID}/pinCodes`;
export const API_SECTION_USER_NOTES = `${API_SECTION_BY_ID}/users/${PARAMS.USER}/notes?unitActivityId=${PARAMS.UNIT_ACTIVITY_ID}&fields=${PARAMS.FIELDS}`;
export const API_SECTION_USER_ALL_NOTES = `${API_SECTION_BY_ID}/users/${PARAMS.USER}/notes`;
export const API_SECTION_USER_HIGHLIGHTS = `${API_SECTION_BY_ID}/users/${PARAMS.USER}/highlights`;
export const API_SECTION_USER_NOTE_HIGHLIGHTS = `${API_SECTION_BY_ID}/users/${PARAMS.USER}/note-highlights`;
// GROUPS
export const API_GROUPS = `${config.BACKEND_URL}${API_PREFIX}/groups`;
export const API_GROUPS_PICTOGRAMS = `${config.BACKEND_URL}${API_PREFIX}/groups/pictograms`;
export const API_GROUPS_STUDENTS = `${API_GROUPS}/${PARAMS.GROUP}/students`;

export const API_SCHOOLS = `${config.BACKEND_URL}${API_PREFIX}/institutions`;
export const API_STATUS = `${config.BACKEND_URL}${API_PREFIX}/status`;
export const API_BOOKS = `${config.BACKEND_URL}${API_PREFIX}/books`;
export const API_BOOKS_LINKED = `${API_BOOKS}/linked?activityId=${PARAMS.ACTIVITY}`;
/** @deprecated Prefer API_ACTIVITIES_IMPORTED — same query for book/unit/lesson. */
export const API_BOOKS_IMPORTED = `${API_BOOKS}/imported?bookId=${PARAMS.BOOK}`;
export const API_ACTIVITIES_IMPORTED = `${config.BACKEND_URL}${API_PREFIX_V2}/activities/imported?activityId=${PARAMS.ACTIVITY}`;
export const API_ACTIVITIES_LINKED = `${config.BACKEND_URL}${API_PREFIX}/activities/linked?activityId=${PARAMS.ACTIVITY}&sectionId=${PARAMS.SECTION}`;
export const API_ACTIVITY_UNLINK = `${API_CLASSROOM}/activities/${PARAMS.ACTIVITY}/unlink`;

// API DOWNLOAD
export const API_INSTALLERS = `${config.DOWNLOAD_URL}${API_PREFIX}/installers?platform=${PARAMS.PLATFORM}&architecture=${PARAMS.ARCHITECTURE}`;

// API BACKOFFICE
export const API_BACKOFFICE = `${config.BACKOFFICE_URL}`;
export const API_BACKOFFICE_AUTHORIZATION = `${API_BACKOFFICE}/v1/authorization`;
export const API_BACKOFFICE_SCHOOL_BOOKS = `${API_BACKOFFICE}/v1/schools/${PARAMS.SCHOOL}/books?bookUri=${PARAMS.BOOK}`;
// CUSTOMERS
export const API_BACKOFFICE_CUSTOMERS = `${config.BACKOFFICE_URL}/v1/customers`;
export const API_BACKOFFICE_CUSTOMERS_V2 = `${config.BACKOFFICE_URL}/v2/customers`;
export const API_BACKOFFICE_CUSTOMER = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}`;
export const API_BACKOFFICE_SCHOOLS = `${API_BACKOFFICE_CUSTOMER}/schools/${PARAMS.SCHOOL}`;
export const API_BACKOFFICE_SCHOOLS_CONFIGURATION = `${API_BACKOFFICE_CUSTOMERS_V2}/${PARAMS.CUSTOMER}/schools/${PARAMS.SCHOOL}/configuration`;
export const API_BACKOFFICE_ASSETS = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/assets/${PARAMS.ASSET}`;
export const API_BACKOFFICE_ASSETS_UPLOAD = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/assets`;
export const API_BACKOFFICE_ASSETS_UPLOAD_AVAILABILITY = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/assets/checkAvailability`;
export const API_BACKOFFICE_ASSETS_UPLOAD_PRESIGN = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/assets/upload/presign`;
export const API_BACKOFFICE_CUSTOMERS_BOOKS_METAS = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/bookmetadatas`;
export const API_BACKOFFICE_CUSTOMERS_CONFIG = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/configuration`;
// CustomerTranslations
export const API_BACKOFFICE_CUSTOMER_TRANSLATIONS = `${API_BACKOFFICE_CUSTOMERS}/${PARAMS.CUSTOMER}/translations`;

// ANALYTICS EVENTS
export const API_ANALYTICS_EVENTS = `${config.BACKEND_URL}${API_PREFIX}/analytics/events`;

// GRADES
export const API_BACKOFFICE_GRADES = `${config.BACKOFFICE_URL}/v1/grades`;
export const API_BACKOFFICE_BOOK_GRADES = `${API_BACKOFFICE_GRADES}?sectionId=${PARAMS.SECTION}&book=${PARAMS.BOOK}`;
export const API_BACKOFFICE_UNIT_GRADES = `${API_BACKOFFICE_GRADES}?sectionId=${PARAMS.SECTION}&unit=${PARAMS.UNIT}`;
export const API_BACKOFFICE_LESSON_GRADES = `${API_BACKOFFICE_GRADES}?sectionId=${PARAMS.SECTION}&lesson=${PARAMS.LESSON}`;
export const API_CLASSROOM_BOOK_CSV = `${API_BACKOFFICE_GRADES}/csv?sectionId=${PARAMS.SECTION}&book=${PARAMS.BOOK}`;
// SKIN
export const API_BACKOFFICE_SKIN = `${config.BACKOFFICE_URL}/v1/skin/customer`;
export const API_BACKOFFICE_TEMPLATE = `${API_BACKOFFICE_SKIN}/${PARAMS.CUSTOMER}`;
export const API_BACKOFFICE_SKIN_VERSION = `${API_BACKOFFICE_SKIN}/${PARAMS.CUSTOMER}/version`;
export const API_BACKOFFICE_SKIN_DOWNLOAD = `${API_BACKOFFICE_SKIN}/${PARAMS.CUSTOMER}/download`;
// API CMS
export const API_CMS = `${config.CMS_URL}${API_CMS_PREFIX}`;
export const API_CMS_SEARCH = `${API_CMS}/search?customerId=${PARAMS.CUSTOMER}&schoolId=${PARAMS.SCHOOL}&type=${PARAMS.TYPE}`;
export const API_CMS_CUSTOMERS_ACTIVITIES_TREE = `${API_CMS}/customers/${PARAMS.CUSTOMER}/activities/tree`;
export const API_CMS_CUSTOMERS_ACTIVITIES_PREVIEW = `${API_CMS}/customers/${PARAMS.CUSTOMER}/activities/preview`;
export const API_CMS_CUSTOMERS_RESOURCES_PREVIEW = `${API_CMS}/customers/${PARAMS.CUSTOMER}/resources/preview`;
export const API_CMS_RESOURCES = `${API_CMS}/customers/${PARAMS.CUSTOMER}/resources`;
// CDN
export const API_CDN = `${config.CDN_URL}`;
export const API_CDN_VERSION = `${API_CDN}/about.json`;
export const API_CDN_DOWNLOAD = `${API_CDN}/cdn.zip`;
// XAPI TRACKING
export const API_EXTERNAL_TRACKING = `${config.BACKOFFICE_URL}/v1/xapi/tracking`;
export const API_EXTERNAL_ACTIVITY_RESULTS = `${API_EXTERNAL_TRACKING}/sectionResults`;
export const API_EXTERNAL_ACTIVITY_TRACKING_INSTRUCTOR = `${API_EXTERNAL_TRACKING}/activityTracking`;
export const API_EXTERNAL_ACTIVITY_TRACKING_STUDENT = `${API_EXTERNAL_TRACKING}/activityTrackingStudent`;
export const API_EXTERNAL_ACTIVITY_TRACKING_ALL_STUDENTS = `${API_EXTERNAL_TRACKING}/activityTrackingStudents`;
export const API_EXTERNAL_ACTIVITY_TRACKING_SUMMARY = `${API_EXTERNAL_TRACKING}/activityTrackingSummary`;

export const API_EXTERNAL_SCHOOLS_BOOKS = `${config.BACKOFFICE_URL}/v1/schools/${PARAMS.SCHOOL}/books`;
export const API_EXTERNAL_PRESENCES = `${config.PRESENCE_URL}/api/v1/presences`;
export const API_BASIC_ANALYTICS = `${config.BACKOFFICE_URL}/v1/analytics?sectionId=${PARAMS.SECTION}&month=${PARAMS.MONTH}&year=${PARAMS.YEAR}&timezone=${PARAMS.TIME_ZONE}`;

export const API_CLASSROOM_STUDENTS_CSV = `${config.BACKEND_URL}${API_PREFIX}/sections/${PARAMS.CLASSROOM}/students/csv`;

// API DISCUSSIONS
export const API_DISCUSSIONS = `${config.DISCUSSIONS_URL}${API_PREFIX}/discussions`;
export const API_DISCUSSION = `${API_DISCUSSIONS}/${PARAMS.DISCUSSION}`;
export const API_DISCUSSION_POSTS = `${API_DISCUSSION}/messages`;
export const API_STATEMENTS = `${config.BACKOFFICE_URL}/v1/xapi/statements`;

// NETEX CLOUD
export const NETEX_CLOUD_MENU_URL = `${API_BACKOFFICE}/v1/netexcloud/menu`;

// OPENSALT
export const API_OPENSALT = config.OPENSALT_URL;

// WEB SERVER
export const API_WEB_SERVER = config.WEB_SERVER_URL;
export const API_WEB_SERVER_ASSETS_SKINS = `${API_WEB_SERVER}/assets/skins/${PARAMS.SKIN}`;
